import { Link, useNavigate, useLocation } from "react-router-dom";
import State, { STATE, LoginFlowState, InvitationState } from "@state";
import AuthLayout from "../../../components/layout/AuthLayout";
import Button from "../../../components/ui/Button";
import FormInput from "../../../components/layout/FormInput";
import { useState, useEffect } from "react";
import InvitationController from "@/network/controllers/invitation.controller";

export default function UserSignup() {
  const navigate = useNavigate();
  const location = useLocation();
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [countdown, setCountdown] = useState(2);
  const [isLoadingInvitation, setIsLoadingInvitation] = useState(false);
  const [invitationError, setInvitationError] = useState(null);

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: STATE[InvitationState.INVITATION_USED_EMAIL],
    street: "",
    number: "",
    country: "",
    city: "",
    postalCode: "",
    contactNumber: "",
    assignedSiteName: "",
    assignedInvestigatorName: "",
    assignedCompanyName: "",
    entity_id: null,
    phone_number: "",
    postal_address_1: "",
    postal_address_2: "",
    zipcode: "",
    investigator_id: null,
    site_id: null,
    study_id: null,
    invitationType: null,
  });

  const [errors, setErrors] = useState({});
  const [invitationParams, setInvitationParams] = useState({
    invitationId: null,
    authId: null,
    type: null,
    studyId: null,
  });

  const isPatientInvitationFlow =
    STATE[LoginFlowState.LOGIN_FLOW] === LoginFlowState.FROM_INVITATION_FLOW &&
    STATE[InvitationState.INVITATION_TYPE] === InvitationState.INVITATION_TYPE_JOIN_STUDY_PATIENT;

  const isCroInvitationFlow =
    STATE[LoginFlowState.LOGIN_FLOW] === LoginFlowState.FROM_INVITATION_FLOW &&
    (STATE[InvitationState.INVITATION_TYPE] === InvitationState.INVITATION_TYPE_NEW_CRO ||
      STATE[InvitationState.INVITATION_TYPE] === InvitationState.INVITATION_TYPE_JOIN_CRO);

  const isInvestigatorInvitationFlow =
    STATE[LoginFlowState.LOGIN_FLOW] === LoginFlowState.FROM_INVITATION_FLOW &&
    STATE[InvitationState.INVITATION_TYPE] === InvitationState.INVITATION_TYPE_JOIN_STUDY_INVESTIGATOR;


    useEffect(() => {
      const invitationContent = STATE[InvitationState.INVITATION_CONTENT];
    
      if (invitationContent) {
        setFormData(prev => ({
          ...prev,
          email: invitationContent.email || "",
          firstName: invitationContent.firstname || "",
          lastName: invitationContent.lastname || "",
          assignedSiteName: invitationContent.site_name || "",
          assignedSiteId: invitationContent.site_id || null,
          entity_id: invitationContent.entity_id || null,
          contactNumber: invitationContent.phone_number || "",
          street: invitationContent.postal_address_1 || "",
          number: invitationContent.postal_address_2 || "",
          country: invitationContent.country || "",
          city: invitationContent.city || "",
          postalCode: invitationContent.zipcode || "",
          investigator_id: invitationContent.investigator_id || null,
          site_id: invitationContent.site_id || null,
          study_id: invitationContent.study_id || null,
          assignedInvestigatorName:
            invitationContent.investigator_firstname && invitationContent.investigator_lastname
              ? `${invitationContent.investigator_firstname} ${invitationContent.investigator_lastname}`
              : "",
          assignedCompanyName: invitationContent.assigned_company_name || "",
          invitationType: invitationContent.invitation_type,
        }));
      }
    }, []);
    

    /** ------------------ cmt 159146 ------------------
    useEffect(() => { 
    /** ------------------ cmt 188264 ------------------
    const queryParams = new URLSearchParams(location.search);
    const invitationId = queryParams.get("invitationId");
    const authId = queryParams.get("authId");
    const typeFromUrl = queryParams.get("type");
    const studyIdFromUrl = queryParams.get("study_id");

    setInvitationParams({
      invitationId,
      authId,
      type: typeFromUrl,
      studyId: studyIdFromUrl,
    });


    return;

    const fetchInvitationDetails = async () => {
      if (invitationId && authId) {
        try {
          const response = await InvitationController.getInvitationDetails(
            invitationId,
            authId,
            ["pending", "joined"]
          );
          console.log("Invitation Data:");
          console.log(
            "=== response.data === UserSignup.jsx === key: 631049 ==="
          );
          console.dir(response.data, { depth: null, colors: true });
          console.log("=================================");

          if (response.success && response.data) {
            const {
              email,
              firstname,
              lastname,
              site_name,
              site_id,
              invitation_type,
              entity_id,
              phone_number,
              postal_address_1,
              postal_address_2,
              country,
              city,
              zipcode,
              investigator_id,
              investigator_firstname,
              investigator_lastname,
              assigned_company_name,
              study_id: fetched_study_id,
              delegate,
            } = response.data;

            setFormData((prev) => ({
              ...prev,
              email: email || "",
              firstName: firstname || "",
              lastName: lastname || "",
              assignedSiteName: site_name || "",
              assignedSiteId: site_id || null,
              entity_id: entity_id || null,
              contactNumber: phone_number || "",
              street: postal_address_1 || "",
              number: postal_address_2 || "",
              country: country || "",
              city: city || "",
              postalCode: zipcode || "",
              investigator_id: investigator_id || null,
              site_id: site_id || null,
              study_id: fetched_study_id || studyIdFromUrl || null,
              assignedInvestigatorName:
                investigator_firstname && investigator_lastname
                  ? `${investigator_firstname} ${investigator_lastname}`
                  : "",
              assignedCompanyName: assigned_company_name || "",
              invitationType: invitation_type,
            }));

            let mappedInvitationType = invitation_type;
            switch (invitation_type) {
              case "cro":
                mappedInvitationType = InvitationState.INVITATION_TYPE_NEW_CRO;
                break;
              case "join_cro":
                mappedInvitationType = InvitationState.INVITATION_TYPE_JOIN_CRO;
                break;
              case "investigator":
                mappedInvitationType =
                  InvitationState.INVITATION_TYPE_JOIN_STUDY_INVESTIGATOR;
                break;
              case "participant":
                mappedInvitationType =
                  InvitationState.INVITATION_TYPE_JOIN_STUDY_PATIENT;
                break;
              default:
                console.warn(
                  `Unknown invitation_type from backend: ${invitation_type}. Using it as is.`
                );
                break;
            }
            State.setValue(
              InvitationState.INVITATION_TYPE,
              mappedInvitationType
            );
            State.setValue(InvitationState.INVITATION_USED_EMAIL, email);
            State.setValue(InvitationState.INVITATION_CONTENT, response.data);
            State.setValue(
              LoginFlowState.LOGIN_FLOW,
              LoginFlowState.FROM_INVITATION_FLOW
            );
          } else {
            setInvitationError(
              response.message || "Failed to load invitation details."
            );
            alert(response.message || "Failed to load invitation details.");
          }
        } catch (err) {
          console.error("Error fetching invitation details:", err);
          setInvitationError(
            "An unexpected error occurred while loading invitation details."
          );
          alert(
            "An unexpected error occurred while loading invitation details."
          );
        } finally {
          setIsLoadingInvitation(false);
        }
      } else {
        setIsLoadingInvitation(false);
        State.setValue(
          LoginFlowState.LOGIN_FLOW,
          LoginFlowState.NORMAL_SIGNUP_FLOW
        );
      }
    };
    fetchInvitationDetails();
  }, [location.search]);

    *-------------------------------------------------*/
  

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    // Check required fields

    [
      "firstName",
      "lastName",
      "email",
      "street",
      "number",
      "country",
      "city",
      "postalCode",
      "contactNumber",
    ].forEach((key) => {
      if (!formData[key].trim()) {
        newErrors[key] = "This field is required";
      }
    });
    // Validate contact number format (simple validation)
    if (
      formData.contactNumber &&
      !/^[+]?[\d\s()-]{8,}$/.test(formData.contactNumber)
    ) {
      newErrors.contactNumber = "Please enter a valid phone number";
    }
    // Validate postal code (simple validation)
    if (formData.postalCode && !/^[\d\s-]{3,10}$/.test(formData.postalCode)) {
      newErrors.postalCode = "Please enter a valid postal code";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    const invitationContent = STATE[InvitationState.INVITATION_CONTENT];
    e.preventDefault();
    if (validateForm()) {
      // Store data in global state then redirect to password step
      State.setValue(LoginFlowState.SIGNUP_USER_FORM_DATA, {
        ...formData,
        invitationId: invitationContent.id,
        authId: "",
        invitationType: invitationContent.invitation_type,
        assignedSiteId: invitationContent.site_id,
        entity_id: invitationContent.entity_id,
        investigator_id: invitationContent.investigator_id,
        site_id: invitationContent.site_id,
        study_id: invitationContent.study_id,
      });
      navigate("/user-signup-password");
      return;
      setIsSubmitted(true);
    }
  };

  if (isLoadingInvitation) {
    return (
      <AuthLayout
        title="Loading Invitation"
        subtitle="Please wait while we load your invitation details."
        logoSrc="/img/logo.png"
        imageSrc="/img/Oshimed sign in image - earth.png"
        formWidth="half"
        contentPadding="small"
        maxWidth="full"
      >
        <div className="text-center py-8">
          <p className="text-lg font-medium text-gray-900">
            Loading invitation...
          </p>
        </div>
      </AuthLayout>
    );
  }

  if (invitationError) {
    return (
      <AuthLayout
        title="Invitation Error"
        subtitle="There was an issue with your invitation."
        logoSrc="/img/logo.png"
        imageSrc="/img/Oshimed sign in image - earth.png"
        formWidth="half"
        contentPadding="small"
        maxWidth="full"
      >
        <div className="text-center py-8">
          <p className="text-lg font-medium text-red-600">{invitationError}</p>
          <p className="text-sm text-gray-600 mt-2">
            Please contact support or try again with a valid link.
          </p>
        </div>
      </AuthLayout>
    );
  }

  return (
    <AuthLayout
      title=""
      subtitle=""
      logoSrc="/img/logo.png"
      imageSrc="/img/Oshimed sign in image - earth.png"
      formWidth="half"
      contentPadding="small"
      maxWidth="full"
    >
      <div className="rounded-xl p-6 w-full">
        <h2 className="text-2xl font-semibold mb-6 text-center">
          Create User Account
        </h2>
        <form className="space-y-4 w-full" onSubmit={handleSubmit}>
          {/* First name, Last name and Email */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <FormInput
              label="First name"
              id="firstName"
              name="firstName"
              type="text"
              placeholder="First name"
              required
              value={formData.firstName}
              onChange={handleChange}
              error={errors.firstName}
              readOnly={isPatientInvitationFlow}
              disabled={isPatientInvitationFlow}
            />
            <FormInput
              label="Last name"
              id="lastName"
              name="lastName"
              type="text"
              placeholder="Last name"
              required
              value={formData.lastName}
              onChange={handleChange}
              error={errors.lastName}
              readOnly={isPatientInvitationFlow}
              disabled={isPatientInvitationFlow}
            />
            <FormInput
              label="Email"
              id="email"
              name="email"
              type="email"
              placeholder="name@example.com"
              required
              value={formData.email}
              onChange={handleChange}
              error={errors.email}
              readOnly={
                isPatientInvitationFlow ||
                isInvestigatorInvitationFlow ||
                isCroInvitationFlow
              }
              disabled={
                isPatientInvitationFlow ||
                isInvestigatorInvitationFlow ||
                isCroInvitationFlow
              }
            />
          </div>
          {/* Office address and Number */}
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
            <div className="md:col-span-3">
              <FormInput
                label="Address - Street"
                id="street"
                name="street"
                type="text"
                placeholder="Avenue of modern clinical studies"
                required
                value={formData.street}
                onChange={handleChange}
                error={errors.street}
                readOnly={isPatientInvitationFlow}
                disabled={isPatientInvitationFlow}
              />
            </div>
            <FormInput
              label="Number"
              id="number"
              name="number"
              type="text"
              placeholder="123"
              required
              value={formData.number}
              onChange={handleChange}
              error={errors.number}
              readOnly={isPatientInvitationFlow}
              disabled={isPatientInvitationFlow}
            />
          </div>
          {/* Country, City/Town, Postal code */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <FormInput
              label="Country"
              id="country"
              name="country"
              type="text"
              placeholder="France"
              required
              value={formData.country}
              onChange={handleChange}
              error={errors.country}
              readOnly={isPatientInvitationFlow}
              disabled={isPatientInvitationFlow}
            />
            <FormInput
              label="City / Town"
              id="city"
              name="city"
              type="text"
              placeholder="Paris"
              required
              value={formData.city}
              onChange={handleChange}
              error={errors.city}
              readOnly={isPatientInvitationFlow}
              disabled={isPatientInvitationFlow}
            />
            <FormInput
              label="Postal code"
              id="postalCode"
              name="postalCode"
              type="text"
              placeholder="75000"
              required
              value={formData.postalCode}
              onChange={handleChange}
              error={errors.postalCode}
              readOnly={isPatientInvitationFlow}
              disabled={isPatientInvitationFlow}
            />
          </div>
          {/* Contact number and Assigned site */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <FormInput
              label="Contact number"
              id="contactNumber"
              name="contactNumber"
              type="tel"
              placeholder="+1 24 61 23 76 54"
              required
              value={formData.contactNumber}
              onChange={handleChange}
              error={errors.contactNumber}
              readOnly={isPatientInvitationFlow}
              disabled={isPatientInvitationFlow}
            />

            {isCroInvitationFlow ? (
              <FormInput
                label="Assigned company"
                id="assignedCompanyName"
                name="assignedCompanyName"
                type="text"
                placeholder="Assigned company"
                value={formData.assignedCompanyName}
                readOnly={true}
                disabled={true}
              />
            ) : (
              <>
                {/* Assigned site */}
                <FormInput
                  label="Assigned site"
                  id="assignedSiteName"
                  name="assignedSiteName"
                  type="text"
                  placeholder="Assigned site"
                  value={formData.assignedSiteName}
                  readOnly={
                    isPatientInvitationFlow || isInvestigatorInvitationFlow
                  }
                  disabled={
                    isPatientInvitationFlow || isInvestigatorInvitationFlow
                  }
                />

                {!isInvestigatorInvitationFlow && (
                  <FormInput
                    label="Assigned investigator"
                    id="assignedInvestigatorName"
                    name="assignedInvestigatorName"
                    type="text"
                    placeholder="Assigned investigator"
                    value={formData.assignedInvestigatorName}
                    readOnly={isPatientInvitationFlow}
                    disabled={isPatientInvitationFlow}
                  />
                )}
              </>
            )}
          </div>
          {/* Continue button */}
          <div className="mt-6 flex flex-col items-center">
            <Button type="submit" variant="login" className="">
              Create Account
            </Button>
            <p className="text-gray-600 text-sm mt-4">
              Already have an account?{" "}
              <Link
                to="/user-signin"
                className="text-linkColor font-semibold hover:underline"
              >
                Sign in
              </Link>
            </p>
          </div>
        </form>
        {/* Terms and conditions */}
        <div className="mt-4 text-center">
          <p className="text-gray-600 text-sm">
            By creating an account, you agree to Oshimed's{" "}
            <Link to="/conditions-of-use" className="text-linkColor">
              Conditions of use
            </Link>
          </p>
        </div>
      </div>
    </AuthLayout>
  );
}
